/* ============================================================
   UPPAbaby Australia — core behaviour
   Shared by every template.

   Principle carried from the v3 build: never hide critical
   content behind a JS-added class. Everything here enhances
   markup that already reads correctly with JS off.
   ============================================================ */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return innerWidth < 861; };

  /* ---------- icon sprite ----------
     Decorative only. Every icon sits beside real text, so
     injecting this from JS costs nothing if JS fails. */
  /* ---------------------------------------------------------- ENTRY MOTION
   The hero settles in on load. The rules live behind .ub-anim so that no-JS,
   a stylesheet that never arrives, or an animation clock that never ticks all
   leave the hero plainly visible rather than stuck at opacity 0. A watchdog
   pulls the class back off if the animation has not actually run, because an
   invisible hero is far worse than one that simply appears. */
(function () {
  try {
    var reduceMotion = window.matchMedia &&
      matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;
    var root = document.documentElement;
    root.classList.add('ub-anim');
    setTimeout(function () {
      var el = document.querySelector('.hero-in > *, .pdp-hero-in > *, .hr-hero-in > *');
      if (el && parseFloat(getComputedStyle(el).opacity) < 0.9) {
        root.classList.remove('ub-anim');
      }
    }, 2600);
  } catch (e) {
    document.documentElement.classList.remove('ub-anim');
  }
})();

/* ------------------------------------------------ video that opens on scroll
   Sets --vg from 0 to 1 across the band's approach to the middle of the
   screen. The CSS starts at the OPEN state, so a browser that never runs this
   shows a full-width film rather than a small box marooned mid-page. */
(function () {
  try {
    var grow = [].slice.call(document.querySelectorAll('.vband-grow'));
    if (!grow.length) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* Only close the bands that are below the fold. Zeroing all of them
       defeats the CSS fallback above: if the script initialises but never gets
       a frame, an on-screen band would sit stranded at 76% instead of showing
       as the full width film the CSS defaults to. */
    grow.forEach(function (el) {
      if (el.getBoundingClientRect().top > innerHeight) {
        el.style.setProperty('--vg', '0');
      }
    });
    var ticking = false;
    function frame() {
      ticking = false;
      var vh = innerHeight;
      grow.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        /* 0 when the top is a screen below the fold, 1 once it has reached a
           third of the way up. Clamped, so it never overshoots either end. */
        var p = 1 - ((r.top - vh * 0.32) / (vh * 0.68));
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
        el.style.setProperty('--vg', p.toFixed(3));
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    frame();
  } catch (e) {
    [].slice.call(document.querySelectorAll('.vband-grow')).forEach(function (el) {
      el.style.setProperty('--vg', '1');
    });
  }
})();

var SPRITE = '<svg class="sprite" aria-hidden="true" focusable="false"><defs>' +
    '<g id="i-shield"><path pathLength="1" d="M12 3.2 19 6v4.9c0 4.3-2.9 7.6-7 9.9-4.1-2.3-7-5.6-7-9.9V6z"/></g>' +
    '<g id="i-tune"><line pathLength="1" x1="3.5" y1="7.5" x2="20.5" y2="7.5"/><line pathLength="1" x1="3.5" y1="16.5" x2="20.5" y2="16.5"/><circle pathLength="1" cx="9" cy="7.5" r="2.4"/><circle pathLength="1" cx="15.5" cy="16.5" r="2.4"/></g>' +
    '<g id="i-verified"><circle pathLength="1" cx="12" cy="12" r="8.4"/><polyline pathLength="1" points="8.2,12.3 10.9,15 15.9,9.4"/></g>' +
    '<g id="i-info"><circle pathLength="1" cx="12" cy="12" r="8.4"/><line pathLength="1" x1="12" y1="11" x2="12" y2="16.4"/><line pathLength="1" x1="12" y1="7.7" x2="12" y2="8"/></g>' +
    '<g id="i-calendar"><rect pathLength="1" x="3.6" y="5.4" width="16.8" height="15" rx="1.4"/><line pathLength="1" x1="3.6" y1="10" x2="20.4" y2="10"/><line pathLength="1" x1="8.2" y1="3.4" x2="8.2" y2="7"/><line pathLength="1" x1="15.8" y1="3.4" x2="15.8" y2="7"/></g>' +
    '<g id="i-people"><circle pathLength="1" cx="9.2" cy="9" r="3.2"/><path pathLength="1" d="M3.4 20c0-3.3 2.6-5.6 5.8-5.6S15 16.7 15 20"/><path pathLength="1" d="M16.2 6.3a3.2 3.2 0 0 1 0 6"/><path pathLength="1" d="M17.4 14.7c1.9.7 3.2 2.5 3.2 5.3"/></g>' +
    '<g id="i-play"><circle pathLength="1" cx="12" cy="12" r="8.4"/><path pathLength="1" d="M10.2 8.8 16 12l-5.8 3.2z"/></g>' +
    '<g id="i-compass"><circle pathLength="1" cx="12" cy="12" r="8.4"/><path pathLength="1" d="m15.4 8.6-2 4.8-4.8 2 2-4.8z"/></g>' +
    '<g id="i-globe"><circle pathLength="1" cx="12" cy="12" r="8.4"/><line pathLength="1" x1="3.6" y1="12" x2="20.4" y2="12"/><path pathLength="1" d="M12 3.6c2.2 2.3 3.4 5.3 3.4 8.4s-1.2 6.1-3.4 8.4c-2.2-2.3-3.4-5.3-3.4-8.4S9.8 5.9 12 3.6"/></g>' +
    '<g id="i-pin"><path pathLength="1" d="M12 21c3.7-4.4 5.6-7.6 5.6-10a5.6 5.6 0 1 0-11.2 0c0 2.4 1.9 5.6 5.6 10"/><circle pathLength="1" cx="12" cy="10.7" r="2.2"/></g>' +
    '<g id="i-clock"><circle pathLength="1" cx="12" cy="12" r="8.4"/><polyline pathLength="1" points="12,6.9 12,12 15.6,14"/></g>' +
    /* added for the informational templates */
    '<g id="i-search"><circle pathLength="1" cx="10.8" cy="10.8" r="6.6"/><line pathLength="1" x1="15.6" y1="15.6" x2="20.4" y2="20.4"/></g>' +
    '<g id="i-doc"><path pathLength="1" d="M6 3.4h8l4.4 4.4v12.8H6z"/><polyline pathLength="1" points="14,3.4 14,8 18.4,8"/><line pathLength="1" x1="9" y1="13" x2="15.4" y2="13"/><line pathLength="1" x1="9" y1="16.4" x2="15.4" y2="16.4"/></g>' +
    '<g id="i-tools"><path pathLength="1" d="M14.8 4.4a4.2 4.2 0 0 0 5.4 5.4L10 20a2.3 2.3 0 0 1-3.3-3.3z"/><line pathLength="1" x1="5.2" y1="5.2" x2="9.4" y2="9.4"/></g>' +
    '<g id="i-swap"><polyline pathLength="1" points="7.4,4.6 3.8,8.2 7.4,11.8"/><line pathLength="1" x1="3.8" y1="8.2" x2="19.4" y2="8.2"/><polyline pathLength="1" points="16.6,12.2 20.2,15.8 16.6,19.4"/><line pathLength="1" x1="20.2" y1="15.8" x2="4.6" y2="15.8"/></g>' +
    '<g id="i-gift"><rect pathLength="1" x="3.6" y="9" width="16.8" height="11.4" rx="1.2"/><line pathLength="1" x1="3.6" y1="13.2" x2="20.4" y2="13.2"/><line pathLength="1" x1="12" y1="9" x2="12" y2="20.4"/><path pathLength="1" d="M12 9C10.6 5.4 8.8 4 7.4 4.6S6.2 8.2 12 9c1.4-3.6 3.2-5 4.6-4.4s1.2 3.6-4.6 4.4"/></g>' +
    '<g id="i-mail"><rect pathLength="1" x="3.4" y="5.6" width="17.2" height="12.8" rx="1.4"/><polyline pathLength="1" points="3.4,7 12,13 20.6,7"/></g>' +
    '<g id="i-store"><path pathLength="1" d="M4 9.4h16v10.2H4z"/><path pathLength="1" d="M3.2 9.4 5 4.4h14l1.8 5"/><line pathLength="1" x1="9.6" y1="19.6" x2="9.6" y2="13.6"/><line pathLength="1" x1="14.4" y1="13.6" x2="14.4" y2="19.6"/></g>' +
    '<g id="i-camera"><rect pathLength="1" x="3.4" y="7" width="17.2" height="13" rx="1.6"/><circle pathLength="1" cx="12" cy="13.5" r="3.6"/><path pathLength="1" d="M8.6 7 10 4.4h4L15.4 7"/></g>' +
    '<g id="i-box"><path pathLength="1" d="M12 3.4 20.4 8v8L12 20.6 3.6 16V8z"/><polyline pathLength="1" points="3.6,8 12,12.6 20.4,8"/><line pathLength="1" x1="12" y1="12.6" x2="12" y2="20.6"/></g>' +
    '<g id="i-leaf"><path pathLength="1" d="M20 4.4c0 8.6-4.6 13.2-11.2 13.2A4.8 4.8 0 0 1 4 12.8C4 7.2 10.4 4.4 20 4.4"/><line pathLength="1" x1="4.6" y1="19.6" x2="13.4" y2="10.8"/></g>' +
    '</defs></svg>';

  var s = document.createElement('div');
  s.innerHTML = SPRITE;
  document.body.insertBefore(s.firstChild, document.body.firstChild);

  /* ---------- mobile drawer ---------- */
  var nav = document.getElementById('nav'),
      burger = document.getElementById('burger'),
      drawer = document.getElementById('drawer');

  function setDrawer(open) {
    if (!nav || !drawer) return;
    nav.classList.toggle('open', open);
    drawer.classList.toggle('on', open);
    burger.setAttribute('aria-expanded', open);
    document.body.classList.toggle('locked', open);
  }
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      setDrawer(!drawer.classList.contains('on'));
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setDrawer(false); });
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });
  }

  /* ---------- nav solidifies on scroll + progress bar ---------- */
  var bar = document.getElementById('progress');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = scrollY;
      if (nav) nav.classList.toggle('solid', y > 8);
      if (bar) {
        var h = document.documentElement.scrollHeight - innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(y / h, 1) : 0).toFixed(4) + ')';
      }
      ticking = false;
    });
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- reveal on entry ----------
     These start at opacity 0, so anything that stops this running leaves real
     content permanently invisible. Three things make that safer than it was:

     A threshold of 0.18 could never be met by an element more than about five
     screens tall, because 18% of it does not fit in the viewport. Zero, with a
     margin that waits until it is properly on screen, has no such ceiling.

     And a timer that reveals whatever is left. A missing observer, a hidden
     tab, a script that threw earlier: it does not matter what the reason was,
     the copy still has to appear. */
  var revealables = [].slice.call(document.querySelectorAll('.reveal,.stagger'));

  /* Adding the class is only half the promise: the element still has to be
     painted by a transition, and a transition does not advance in a tab the
     browser has throttled. So each element is checked shortly after it is
     told to appear, and if it has not, it is shown outright with the
     animation taken off. Only fires when something actually failed. */
  function ensure(el) {
    var probe = el.classList.contains('stagger') ? (el.firstElementChild || el) : el;
    setTimeout(function () {
      if (getComputedStyle(probe).opacity === '0') el.classList.add('is-shown');
    }, 2200);
  }
  function reveal(el) {
    if (el.classList.contains('in')) return;
    el.classList.add('in');
    ensure(el);
  }

  /* The safety net used to reveal EVERYTHING on a timer, which meant every
     section below the fold played its animation off screen and was already
     finished by the time anyone scrolled to it: the whole page arrived
     pre-revealed and nothing moved. It now only ever reveals what is actually
     on screen, so a dead observer is covered without the effect being thrown
     away everywhere else. */
  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.top < innerHeight * 0.88 && r.bottom > 0;
  }
  function sweep() {
    for (var i = revealables.length - 1; i >= 0; i--) {
      var el = revealables[i];
      if (el.classList.contains('in')) { revealables.splice(i, 1); continue; }
      if (onScreen(el)) reveal(el);
    }
    if (!revealables.length) clearInterval(sweeper);
  }

  var io;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(reveal);
  }
  var sweeper = setInterval(sweep, 900);
  sweep();

  /* ---------- count up ---------- */
  var counted = new WeakSet();
  function runCount(el) {
    if (counted.has(el)) return;
    counted.add(el);
    var raw = el.dataset.to || el.textContent.replace(/[^\d.]/g, ''),
        to = parseFloat(raw),
        pre = el.dataset.pre || '', post = el.dataset.post || '',
        dp = (el.dataset.dp | 0), dur = 1300, t0 = 0;
    // Only animate a figure that is purely a number. "TBC" used to count to a
    // flat "0", which is not a softer version of unknown but a wrong one; and
    // "180+" would have counted to 180 and quietly dropped the plus. In both
    // cases what was typed is what should show.
    if (!/^\d+(\.\d+)?$/.test(String(raw).trim())) return;
    if (reduce) { el.textContent = pre + to.toFixed(dp) + post; return; }
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3), v = to * e;
      el.textContent = pre + (dp ? v.toFixed(dp) : Math.round(v).toLocaleString('en-AU')) + post;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) runCount(e.target); });
  }, { threshold: 0.6 });
  document.querySelectorAll('.count').forEach(function (el) { cio.observe(el); });

  /* ---------- journal: build the contents rail from the article itself ----------
     The support hub renders its rail server side from written sections. An
     article cannot: the body is rich text typed into Shopify, so the headings
     carry no ids and there is no list to render. This builds one from what the
     body actually contains, which is why it has to run before the scrollspy
     below picks the rail up.

     Ids are prefixed rather than used raw because several headings begin with a
     digit, and querySelector('#1-long-term-durability') throws. */
  var artRail = document.querySelector('[data-autorail]');
  if (artRail) {
    var artDoc = artRail.parentNode;
    var heads = [].slice.call(document.querySelectorAll('.art-body h2'))
      .filter(function (h) { return h.textContent.trim().length > 1; });
    if (heads.length < 3) {
      artRail.parentNode.removeChild(artRail);
      artDoc.classList.add('no-rail');
    } else {
      var rh = document.createElement('h2');
      rh.textContent = 'On this page';
      var rol = document.createElement('ol');
      heads.forEach(function (h) {
        var txt = h.textContent.trim();
        if (!h.id) {
          var base = 'h-' + txt.toLowerCase().replace(/[^a-z0-9]+/g, '-')
                                .replace(/^-+|-+$/g, '').slice(0, 48);
          var id = base, n = 1;
          while (document.getElementById(id)) { id = base + '-' + (++n); }
          h.id = id;
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = txt;
        li.appendChild(a);
        rol.appendChild(li);
      });
      artRail.appendChild(rh);
      artRail.appendChild(rol);
    }
  }

  /* ---------- sticky contents rail: highlight the section in view ---------- */
  var rail = document.querySelector('.rail');
  if (rail) {
    var items = [].slice.call(rail.querySelectorAll('li'));
    var targets = items.map(function (li) {
      var a = li.querySelector('a');
      return a ? document.querySelector(a.getAttribute('href')) : null;
    });
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = targets.indexOf(e.target);
        if (i < 0) return;
        items.forEach(function (li, j) { li.classList.toggle('on', j === i); });
      });
      /* A centre line, not a band. The old rootMargin left a strip only 15%
         of the viewport tall, so a section shorter than that, or a fast
         scroll, could pass through without ever intersecting and the rail
         would keep highlighting the previous chapter. */
    }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
    targets.forEach(function (t) { if (t) rio.observe(t); });

    /* Highlight the first chapter on load, so the rail is never blank
       before the reader has scrolled. */
    if (items.length && !rail.querySelector('li.on')) items[0].classList.add('on');
  }

  /* ---------- 360 spin viewer ----------
     A turntable sequence, dragged. This is what car configurators actually
     do; a spinning wheel on a car site is just video, and there is no trick
     to copy for a still photograph.

     Frames are named by number and preloaded before the control appears, so
     a drag never lands on a blank. Touch drags too. Auto-rotate runs once on
     first sight, then hands over, and never runs for a visitor who has asked
     for reduced motion. */
  [].slice.call(document.querySelectorAll('[data-spin]')).forEach(function (box) {
    var pattern = box.dataset.spin;               /* .../frame-{n}.jpg */
    var count = parseInt(box.dataset.spinFrames, 10) || 0;
    if (!pattern || count < 8) return;

    var img = box.querySelector('img');
    if (!img) return;
    var frames = [], loaded = 0, frame = 0, ready = false;

    for (var i = 1; i <= count; i++) {
      var u = pattern.replace('{n}', String(i).padStart(2, '0'));
      var pre = new Image();
      pre.onload = function () {
        if (++loaded === count) { ready = true; box.classList.add('is-ready'); }
      };
      pre.src = u;
      frames.push(u);
    }

    function show(n) {
      frame = ((n % count) + count) % count;
      img.src = frames[frame];
    }

    var down = false, lastX = 0, acc = 0;
    var STEP = 6;                                  /* px of drag per frame */

    function start(x) { down = true; lastX = x; box.classList.add('is-spinning'); }
    function move(x) {
      if (!down || !ready) return;
      acc += x - lastX;
      lastX = x;
      while (Math.abs(acc) >= STEP) {
        show(frame + (acc > 0 ? 1 : -1));
        acc += acc > 0 ? -STEP : STEP;
      }
    }
    function end() { down = false; acc = 0; box.classList.remove('is-spinning'); }

    box.addEventListener('pointerdown', function (e) { start(e.clientX); box.setPointerCapture(e.pointerId); });
    box.addEventListener('pointermove', function (e) { if (down) { e.preventDefault(); move(e.clientX); } });
    box.addEventListener('pointerup', end);
    box.addEventListener('pointercancel', end);

    /* Keyboard: the drag is not the only way round. */
    box.setAttribute('tabindex', '0');
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(frame + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(frame - 1); }
    });

    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || !ready || box.dataset.spun) return;
          box.dataset.spun = '1';
          var n = 0;
          var t = setInterval(function () {
            show(frame + 1);
            if (++n >= count) clearInterval(t);      /* exactly one turn */
          }, 55);
        });
      }, { threshold: 0.4 });
      io.observe(box);
    }
  });

  /* ---------- drag to scroll, with a cursor that says so ----------
     Our horizontal scrollers worked with arrows, a trackpad swipe or a
     touch swipe, and did nothing at all if you pressed and pulled with a
     mouse, which is the first thing people try. Maserati puts a custom
     cursor on its carousel for exactly this reason: the affordance has to be
     visible or the interaction may as well not exist.

     Pointer events, so mouse and pen share one path. Touch is left alone: it
     already scrolls natively and hijacking it breaks momentum. */
  var draggers = [].slice.call(document.querySelectorAll(
    '.acc-grid, .cats-grid, .cd-rec-row, .scal-wrap, .cmp-scroll, .rcard-row, .mesa-grid'));
  if (draggers.length && matchMedia('(hover:hover)').matches) {
    var cur = document.createElement('div');
    cur.className = 'dragcur';
    cur.setAttribute('aria-hidden', 'true');
    cur.innerHTML = '<span>&#8592;</span><span>&#8594;</span>';
    document.body.appendChild(cur);
    var curOn = false;

    draggers.forEach(function (el) {
      var down = false, startX = 0, startLeft = 0, moved = 0;

      /* Class hook rather than styling the scroller classes directly: naming
         .cats-grid in core.css makes the homepage extractor drop the real
         rule from home.css, which is a bug the build guard now catches. */
      el.classList.add('js-drag');

      el.addEventListener('pointerenter', function () {
        if (el.scrollWidth - el.clientWidth < 8) return;   /* nothing to drag */
        curOn = true; cur.classList.add('is-on');
      });
      el.addEventListener('pointerleave', function () {
        curOn = false; cur.classList.remove('is-on', 'is-down');
      });
      el.addEventListener('pointermove', function (e) {
        if (curOn) cur.style.transform =
          'translate3d(' + (e.clientX - 26) + 'px,' + (e.clientY - 26) + 'px,0)';
      });

      /* Capture the pointer only once it has actually moved. Capturing on
         pointerdown retargets pointerup to the scroller, so the click that
         follows fires on the scroller rather than the card under it, and a
         plain click on a tile navigated nowhere. Six tiles on the homepage
         were dead to a mouse for as long as this ran. */
      var captured = false;
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = 0; captured = false;
        startX = e.clientX; startLeft = el.scrollLeft;
        cur.classList.add('is-down');
      });
      el.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!captured && moved > 6) {
          captured = true;
          try { el.setPointerCapture(e.pointerId); } catch (err) {}
          el.classList.add('is-dragging');
        }
        if (captured) el.scrollLeft = startLeft - dx;
      });
      function end(e) {
        if (!down) return;
        down = false;
        el.classList.remove('is-dragging');
        cur.classList.remove('is-down');
        if (captured) { try { el.releasePointerCapture(e.pointerId); } catch (err) {} }
        captured = false;
      }
      el.addEventListener('pointerup', end);
      el.addEventListener('pointercancel', end);
      /* A drag that ends on a card must not also count as a click on it. */
      el.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* ---------- parallax on full-bleed media ----------
     The media sits taller than its frame and drifts as the band crosses the
     viewport. Transform only, so it never triggers layout, and it is driven
     by one rAF loop rather than a listener per element.

     Off entirely for reduced motion, for touch (where it costs more than it
     gives), and for anything carrying video controls a person needs to hit. */
  var pxElems = [].slice.call(document.querySelectorAll('[data-parallax] img, [data-parallax] video'))
    .filter(function (el) { return !el.closest('.own-grid.is-panels'); });
  if (pxElems.length &&
      !matchMedia('(prefers-reduced-motion: reduce)').matches &&
      matchMedia('(hover:hover)').matches) {
    pxElems.forEach(function (el) { el.style.willChange = 'transform'; });
    var pxTick = false;
    function parallax() {
      pxTick = false;
      var vh = innerHeight;
      pxElems.forEach(function (el) {
        var f = el.parentElement.getBoundingClientRect();
        if (f.bottom < -200 || f.top > vh + 200) return;
        /* -1 when the frame is entering, +1 when it is leaving */
        var p = ((f.top + f.height / 2) - vh / 2) / (vh / 2 + f.height / 2);
        el.style.transform = 'translate3d(0,' + (p * -5).toFixed(2) + '%,0) scale(1.12)';
      });
    }
    addEventListener('scroll', function () {
      if (!pxTick) { pxTick = true; requestAnimationFrame(parallax); }
    }, { passive: true });
    addEventListener('resize', parallax, { passive: true });
    parallax();
  }

  /* ---------- the pinned stage ----------
     Copied from how Maserati runs its model pages: a stage the height of the
     screen that stays put while the page scrolls a screen's worth per panel,
     and panels that wipe up over one another with a clip-path instead of
     sliding or fading. The scroll drives which panel is open; the browser
     animates the wipe.

     Panels already passed stay open underneath the one covering them, so the
     ground never flashes through mid transition.

     The drift on the picture is measured from the panel's place in the
     document, not from its rectangle: while the stage is pinned that
     rectangle does not move, so a viewport-relative reading computes to zero
     and the picture sits dead still for the whole hold. */
  [].slice.call(document.querySelectorAll('.own-grid.is-panels')).forEach(function (grid) {
    var stage = grid.querySelector('.own-stage');
    var panels = [].slice.call(grid.querySelectorAll('article.has-media'));
    if (!stage || panels.length < 2) return;

    panels.forEach(function (p, i) { p.style.zIndex = i + 1; });

    var rail = document.createElement('div');
    rail.className = 'own-rail';
    rail.setAttribute('aria-hidden', 'true');
    rail.appendChild(document.createElement('i'));
    stage.appendChild(rail);
    var fill = rail.firstChild;

    var top = 0, at = -1, tick = false;
    function measure() {
      var y = 0, el = grid;
      while (el) { y += el.offsetTop; el = el.offsetParent; }
      top = y;
    }

    function frame() {
      tick = false;
      if (innerWidth <= 860 || reduce) return;
      var travel = grid.offsetHeight - stage.offsetHeight;
      if (travel <= 0) return;
      var p = (scrollY - top) / travel;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      /* One panel per screen of travel, the last one held for the final screen */
      var i = Math.min(panels.length - 1, Math.floor(p * panels.length));
      if (i !== at) {
        at = i;
        panels.forEach(function (el, j) { el.classList.toggle('is-open', j <= i); });
        fill.style.width = ((i + 1) / panels.length * 100) + '%';
      }
      /* the picture drifts through its own screen of hold */
      var within = p * panels.length - i;
      var m = panels[i].querySelector('img, video');
      if (m) m.style.transform = 'translate3d(0,' + (within * -7).toFixed(2) + '%,0) scale(1.14)';
    }

    function schedule() {
      if (tick) return;
      tick = true;
      requestAnimationFrame(frame);
      setTimeout(frame, 120);   /* a hidden tab pauses the frame, not the page */
    }

    measure();
    panels[0].classList.add('is-open');
    fill.style.width = (1 / panels.length * 100) + '%';
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', function () { measure(); at = -1; frame(); }, { passive: true });
    addEventListener('load', function () { measure(); frame(); });
    frame();
  });

  /* ---------- the second view, on a touch screen ----------
     Hover does the work on a desktop, in CSS. A phone has no hover, so the
     card is made tappable instead: the first tap turns it, the second turns
     it back. Only bound where hover is genuinely unavailable, so a mouse
     never has to click to see what hovering already shows. */
  if (!matchMedia('(hover:hover)').matches) {
    [].slice.call(document.querySelectorAll('.box-cards figure.has-flip, .cfg-card figure.has-flip')).forEach(function (fig) {
      fig.setAttribute('role', 'button');
      fig.setAttribute('tabindex', '0');
      fig.setAttribute('aria-label', 'Show the other view');
      function turn() { fig.classList.toggle('is-flipped'); }
      fig.addEventListener('click', turn);
      fig.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); turn(); }
      });
    });
  }

  /* ---------- sticky buy bar ----------
     Shown once the real add to cart has left the top of the screen, hidden
     again when the footer arrives so it never sits over the legal text. Its
     button clicks the real one rather than posting its own form, so variant
     selection, validation and the cart drawer all keep working through the
     code that already handles them. */
  (function () {
    var bar = document.querySelector('[data-buybar]');
    if (!bar) return;
    var real = document.querySelector('#buy-form button[type=submit]');
    var foot = document.querySelector('footer');
    if (!real) return;

    bar.hidden = false;
    bar.setAttribute('aria-hidden', 'true');

    var btn = bar.querySelector('[data-buybar-add]');
    btn.addEventListener('click', function () { real.click(); });

    var up = false, tick = false;
    function check() {
      tick = false;
      var passed = real.getBoundingClientRect().bottom < 0;
      var footIn = foot ? foot.getBoundingClientRect().top < innerHeight - 40 : false;
      var want = passed && !footIn;
      if (want === up) return;
      up = want;
      bar.classList.toggle('is-up', up);
      /* out of the accessibility tree while it is off screen, so a screen
         reader is not offered a second Add to bag that is not visible */
      bar.setAttribute('aria-hidden', up ? 'false' : 'true');
    }
    function schedule() {
      if (tick) return;
      tick = true;
      requestAnimationFrame(check);
      setTimeout(check, 150);
    }
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    check();
  })();

  /* ---------- chapter markers ----------
     The word travels sideways as its band crosses the screen. Driven from the
     band's own position, transform only, and it starts already offset so the
     movement is visible before the band is fully in view. */
  var marks = [].slice.call(document.querySelectorAll('[data-chapmark]'));
  if (marks.length && !reduce) {
    var mTick = false;
    function marker() {
      mTick = false;
      var vh = innerHeight;
      marks.forEach(function (sec) {
        var row = sec.querySelector('.chapmark-row');
        if (!row) return;
        var r = sec.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var travel = +sec.dataset.speed || 40;
        /* 0 as the band enters the screen, 1 as it leaves */
        var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        var k = (p + 1) / 2;
        k = k < 0 ? 0 : k > 1 ? 1 : k;
        var span = row.scrollWidth - sec.clientWidth;
        /* Always travels LEFT from a resting position of zero. Starting it
           centred meant that with no script the row sat flush left and the
           first word was cut in half; from zero it reads correctly whether
           the script runs or not. */
        var x = -k * (travel / 100) * span;
        row.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      });
    }
    function mSchedule() {
      if (mTick) return;
      mTick = true;
      requestAnimationFrame(marker);
      setTimeout(marker, 120);
    }
    addEventListener('scroll', mSchedule, { passive: true });
    addEventListener('resize', marker, { passive: true });
    addEventListener('load', marker);
    marker();
  }

  /* ---------- broken images never render as bare alt text ---------- */
  addEventListener('error', function (e) {
    var t = e.target;
    if (t.tagName !== 'IMG') return;
    if (t.closest('.hero,.vid,.glob')) return;
    t.style.visibility = 'hidden';
  }, true);

  /* ---------- hero load sequence ---------- */
  function loaded() { document.body.classList.add('loaded'); }
  if (document.readyState === 'complete') loaded();
  else addEventListener('load', loaded);
  setTimeout(loaded, 1800); // fail open: never leave the hero invisible

  /* ---------- parallax, desktop only ----------
     iOS defers scroll events and this judders below 860px. */
  var pxEls = [].slice.call(document.querySelectorAll('[data-px]'));
  if (pxEls.length && !reduce) {
    var pTick = false;
    function parallax() {
      var vh = innerHeight, off = isMobile();
      pxEls.forEach(function (el) {
        if (off) { el.style.transform = ''; return; }
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var centre = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' +
          (centre * -parseFloat(el.dataset.px)).toFixed(1) + 'px,0) scale(1.14)';
      });
      pTick = false;
    }
    addEventListener('scroll', function () {
      if (!pTick) { pTick = true; requestAnimationFrame(parallax); }
    }, { passive: true });
    addEventListener('resize', parallax, { passive: true });
    parallax();
  }

  /* ---------- side scrolling chapters ----------
     The track is a real horizontal scroller, so with no script at all it
     still swipes and snaps. All this does is drive it from the page scroll
     while the section is pinned, which turns a sideways swipe into an
     ordinary downward scroll on a desktop. Nothing is jacked: the page keeps
     moving at its own speed and the panels move with it. */
  [].slice.call(document.querySelectorAll('.hr-chapters.is-side')).forEach(function (sec) {
    var driver = sec.querySelector('.hr-scroll');
    var track = sec.querySelector('.hr-track');
    if (!driver || !track) return;
    var panels = [].slice.call(track.children);
    if (panels.length < 2) return;

    /* If every panel carries a rail, the rail comes out of the track and is
       driven from here instead: one column that holds still while the
       pictures travel past it. Only when they all have one, so a mixed set
       does not end up with a rail that empties on some panels. */
    var fixedRail = sec.querySelector('[data-fixedrail]');
    var railNum = fixedRail && fixedRail.querySelector('[data-rail-num]');
    var railCopy = fixedRail && fixedRail.querySelector('[data-rail-copy]');
    var rails = panels.map(function (p) { return p.querySelector('.hr-rail'); });
    var useRail = fixedRail && rails.every(Boolean);
    if (useRail) sec.classList.add('has-fixedrail');

    function setRail(i) {
      if (!useRail) return;
      var src = rails[i];
      if (!src) return;
      fixedRail.classList.add('is-turning');
      setTimeout(function () {
        var n = src.querySelector('.hr-num');
        var c = src.querySelector('.hr-railcopy');
        if (railNum) railNum.textContent = n ? n.textContent : '';
        if (railCopy) railCopy.innerHTML = c ? c.innerHTML : '';
        fixedRail.classList.remove('is-turning');
      }, 260);
    }

    var dots = document.createElement('div');
    dots.className = 'hr-dots';
    dots.setAttribute('aria-hidden', 'true');
    panels.forEach(function () { dots.appendChild(document.createElement('span')); });
    driver.appendChild(dots);
    var marks = [].slice.call(dots.children);

    var pinned = false, tick = false, at = -1;

    function sync() {
      tick = false;
      if (!pinned) return;
      var span = track.scrollWidth - track.clientWidth;
      var travel = driver.offsetHeight - track.offsetHeight;
      if (span <= 0 || travel <= 0) return;
      var p = -driver.getBoundingClientRect().top / travel;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      track.scrollLeft = p * span;
      var i = Math.round(p * (panels.length - 1));
      if (i !== at) {
        at = i;
        marks.forEach(function (m, j) { m.classList.toggle('on', j === i); });
        setRail(i);
      }
    }

    function setup() {
      var want = innerWidth > 860 && !reduce;
      if (want !== pinned) {
        pinned = want;
        sec.classList.toggle('is-pinned', pinned);
        if (!pinned) track.scrollLeft = 0;
      }
      sync();
    }

    /* A hidden or background tab pauses requestAnimationFrame, and a frame
       that never arrives would leave the flag raised and the track frozen
       part way across. The timer is the second pair of hands: whichever
       fires first clears the flag, and running sync twice costs nothing. */
    function schedule() {
      if (tick) return;
      tick = true;
      requestAnimationFrame(sync);
      setTimeout(sync, 120);
    }
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', setup, { passive: true });
    addEventListener('load', setup);
    setRail(0);
    setup();
  });

  /* ---------- showcase plate drift ----------
     A sticky panel is pinned, so its own rect stops moving and neither a
     scroll-driven CSS timeline nor a getBoundingClientRect parallax can see
     any progress. The progress has to come from the panel's place in the
     track measured against the page scroll instead.

     Sets --shw-bgy from -1 to 1 across the panel's own screen of scrolling.
     CSS multiplies that by 3%, well inside the 4% of headroom the scale
     leaves, so an edge can never come into frame. */
  (function () {
    var panels = [].slice.call(document.querySelectorAll('.shw-stack .shw-panel'));
    if (!panels.length) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var spans = [];
    function measure() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      spans = panels.map(function (p) {
        var r = p.getBoundingClientRect();
        /* a pinned panel reports its pinned top, so take the flow position of
           the track and step through it a panel at a time */
        return { el: p, h: p.offsetHeight || innerHeight };
      });
      var track = panels[0].parentElement;
      var tr = track.getBoundingClientRect();
      var top = tr.top + y;
      var acc = top;
      spans.forEach(function (s) { s.start = acc; acc += s.h; });
    }
    var ticking = false;
    function frame() {
      ticking = false;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      spans.forEach(function (s) {
        var p = (y - s.start) / s.h;          /* 0 at its top, 1 at its bottom */
        if (p < -0.5 || p > 1.5) return;      /* nowhere near: leave it alone */
        var v = (p * 2) - 1;                  /* -1 .. 1 */
        v = v < -1 ? -1 : (v > 1 ? 1 : v);
        s.el.style.setProperty('--shw-bgy', v.toFixed(3));
      });
    }
    /* rAF and a timer, the same pair of hands the chapter track uses. A frame
       that never arrives would leave the flag raised and the plate frozen part
       way through its drift; whichever fires first clears it, and running the
       sync twice costs nothing. */
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
      setTimeout(frame, 120);
    }
    measure(); frame();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', function () { measure(); frame(); }, { passive: true });
    addEventListener('load', function () { measure(); frame(); });
  })();

  /* ---------- collection filters ----------
     Progressive: the form already works with its Apply button. This submits on
     change and closes any other open dropdown, and CSS hides Apply only when
     .js is present, so nothing is stranded if this never runs. */
  /* Two forms carry data-cfilters: the filter bar and the sort select. This
     used to bind the first one only, so choosing a sort did nothing and its
     no-script Apply button was hidden. Every form gets the listener. */
  [].slice.call(document.querySelectorAll('[data-cfilters]')).forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') return;   // let them finish typing
      form.submit();
    });
    document.addEventListener('click', function (e) {
      var open = form.querySelectorAll('details[open]');
      for (var i = 0; i < open.length; i++) {
        if (!open[i].contains(e.target)) open[i].removeAttribute('open');
      }
    });
    form.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      var all = form.querySelectorAll('details[open]');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== e.target) all[i].removeAttribute('open');
      }
    }, true);
  });

  /* ---------- quantity stepper ----------
     Delegated, so it works for the buy form and for any quantity control added
     later without rewiring. The typed field is clamped on the way out as well
     as on the buttons: a browser will happily let someone type 0 or 500 into a
     number input and submit it. */
  (function () {
    function clamp(inp) {
      var min = parseInt(inp.min, 10) || 1;
      var max = parseInt(inp.max, 10) || 99;
      var v = parseInt(inp.value, 10);
      if (isNaN(v)) v = min;
      inp.value = Math.min(max, Math.max(min, v));
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-qty-up],[data-qty-down]');
      if (!b) return;
      var box = b.closest('[data-qty]');
      var inp = box && box.querySelector('.qty-num');
      if (!inp) return;
      inp.value = (parseInt(inp.value, 10) || 1) +
                  (b.hasAttribute('data-qty-up') ? 1 : -1);
      clamp(inp);
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('change', function (e) {
      if (e.target.classList && e.target.classList.contains('qty-num')) clamp(e.target);
    });
  })();

  /* ---------- hero drift offset ----------
     The scroll-driven drift on a pinned hero has to start at the hero's own
     flow offset, not at zero. Start it at zero and the hero climbs faster than
     the page for the first few dozen pixels, lifting its bottom edge clear of
     the section riding up over it and flashing a strip of bare page.

     The hero itself is sticky, so its own rect lies about where it sits in
     flow the moment it pins. The end marker is a static element at the hero's
     flow bottom and tells the truth at any scroll position. Measured on load
     and on resize only: nothing here runs while scrolling. */
  (function () {
    var hero = document.querySelector('.hero-pin');
    var mark = document.querySelector('.hero-endmark');
    if (!hero || !mark) return;
    function measure() {
      var y = mark.getBoundingClientRect().top + window.scrollY - hero.offsetHeight;
      document.documentElement.style.setProperty(
        '--hero-flow-top', Math.max(0, Math.round(y)) + 'px');
    }
    measure();
    addEventListener('load', measure);
    addEventListener('resize', measure, { passive: true });
  })();

  /* ---------- footer link columns ----------
     Four link lists, 27 links, stacked on a phone: the footer measured 1968px
     of a 812px screen and the two column grid left one side empty for three
     rows at a time. The markup ships open so that with JS off nothing is
     hidden; here they close below the breakpoint and reopen above it. */
  (function () {
    var accs = [].slice.call(document.querySelectorAll('.foot-acc'));
    if (!accs.length) return;
    var mq = matchMedia('(max-width: 860px)');
    var sync = function () {
      accs.forEach(function (d) { d.open = !mq.matches; });
    };
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
  })();

  /* ---------- ambient video ----------
     A muted autoplay video is paused by the browser while it is off screen to
     save power, and on some it never starts again on its own. The Mesa spin
     sat frozen on frame one, which reads as a broken picture rather than a
     film. Played when it comes into view, paused when it leaves. */
  (function () {
    var vids = [].slice.call(document.querySelectorAll('.vband .vband-v[autoplay], .vsplit-media video[autoplay]'));
    if (!vids.length) return;
    if (reduce) { vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); }); return; }
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
      return;
    }
    var io2 = new IntersectionObserver(function (rows) {
      rows.forEach(function (row) {
        var v = row.target;
        if (row.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.01 });
    vids.forEach(function (v) { io2.observe(v); });
  })();

  /* expose a couple of helpers for page-level scripts */
  window.UB = { reduce: reduce, isMobile: isMobile,
    observe: function (el) { if (io) io.observe(el); else el.classList.add('in'); } };
})();
